module.exports = __webpack_public_path__ + "img/south_boston.52db9389.jpg";